module.exports = __webpack_public_path__ + "static/media/2021-december-article.553f8aed.jpg";